import { useEffect } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { isEmpty } from "lodash";
// store
import AppStore from "@/app-store";
import Store from "@/core/reducers/SimpleServiceStore";
// actions
import ClientContentsServiceAction from "@/cms/actions/services/ClientContentsServiceAction";
// types
import TClientContentDetail from "@/cms/types/TClientContentDetail";


type TUseContentIn = {
    unqKey:string;
    id:string;
}

const useContent = ( props:TUseContentIn ):TClientContentDetail|null => {
    const dispatch = useDispatch();

    const { unqKey, id } = props;

    const armadorDynamicPayload = document?.getElementById('ARMADORDynamicPayload')?.textContent;
    let _detailsPayload:any = null;
    if ( armadorDynamicPayload && !isEmpty(armadorDynamicPayload) ) {
        const _armadorDynamicPayload = JSON.parse(armadorDynamicPayload);
        _detailsPayload = _armadorDynamicPayload?.[id];
    }

    const clientContentsServiceAction = new ClientContentsServiceAction(dispatch, unqKey);
    AppStore.reducerManager.add(unqKey, Store(unqKey, clientContentsServiceAction.serviceCode));
    const payload = useSelector((state:any) => state?.[unqKey]?.details?.payload, shallowEqual);
    const webApplicationLanguageCode = useSelector((state:any) => state.CoreStore.language?.payload?.code, shallowEqual);

    useEffect(() => { return () => { AppStore.reducerManager.remove(unqKey); } }, [])
    useEffect(() => { if ( id && isEmpty(payload) && isEmpty(_detailsPayload) ) _details(); }, [id])

    const _details = () => {
        clientContentsServiceAction.details({ servicePayload: { key:id, language: webApplicationLanguageCode } });
    }

    if ( !isEmpty(_detailsPayload) ) return _detailsPayload;
    else if ( !isEmpty(payload) ) return payload;
    return null;
}

export default useContent;
